import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AvatarSelection from './AvatarSelection';
import PersonalCommandCenter from './PersonalCommandCenter';
import { Helmet } from 'react-helmet-async';

const ChoresTouch = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Check for user parameter in URL (from Family Command Center)
    useEffect(() => {
        const userParam = searchParams.get('user');
        if (userParam) {
            setSelectedUser(userParam);
        }
    }, [searchParams]);

    const handleBack = () => {
        // Navigate to Family Command Center instead of local avatar selection
        navigate('/family-central');
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Chores Command Center</title>
            </Helmet>
            <Box sx={{ 
                height: '100vh', 
                width: '100vw',
                overflow: 'hidden',
                p: { xs: 1, md: 3 },
                bgcolor: '#f0f2f5'
            }}>
                {selectedUser ? (
                    <PersonalCommandCenter 
                        userId={selectedUser} 
                        onBack={handleBack} 
                    />
                ) : (
                    <AvatarSelection onSelect={setSelectedUser} />
                )}
            </Box>
        </React.Fragment>
    );
};

export default ChoresTouch;
